import { createSagaActionTypes } from '../../../utils/actionFactory';

export const ADD_CONTACT = 'ADD_CONTACT';
export const SET_CONTACT = 'SET_CONTACT';

export const actions = createSagaActionTypes('ADD_EXTERNAL_CONTACT', [
  ADD_CONTACT,
  SET_CONTACT
]);
